import { useLayoutEffect, type RefObject } from "react";

/**
 * Публикует высоту шапки в CSS-переменную `--site-header-height` на корне документа
 * и поддерживает её актуальной при изменении размеров (ResizeObserver).
 *
 * Нужна прилипающим под шапкой элементам (например `.attr-header`), чтобы их `top`
 * совпадал с нижней кромкой шапки, даже когда шапка меняет высоту при ресайзе окна.
 */
export const useHeaderHeightVar = (
  ref: RefObject<HTMLElement | null>,
): void => {
  useLayoutEffect(() => {
    const node = ref.current;

    if (!node) return;

    const updateHeight = () => {
      document.documentElement.style.setProperty(
        "--site-header-height",
        `${node.offsetHeight}px`,
      );
    };

    updateHeight();

    const resizeObserver = new ResizeObserver(updateHeight);
    resizeObserver.observe(node);

    return () => resizeObserver.disconnect();
  }, [ref]);
};
